export class Timesheet {
  id: number;
  projectId: number;
  mainTimesheetId: number;
  transDate: Date;
  timeFrom: Date;
  timeTo: Date;
  workingHours: number;
  checkOnsite:boolean;
  cost:number;
  costOnsite:number;
  description: string;
  projectName: string;
  employeeId: number;
  isBreak: boolean | null = true;
  canAction: boolean;
  projectSites: any[];
  timerange: string;
  timeFromStr: string;
  timeToStr: string;
  updatedBy: string;
  siteId: number;
  siteName: string; 
}



